import React, { forwardRef } from 'react';
import clsx from 'clsx';
import { Panel } from '@/components';

// Dummy markup for tailwind css
/*
<div className="bg-paper"></div>
*/

interface WhitePanelProps extends React.PropsWithChildren {
  className?: string;
  mode?: 'basic' | 'letter';
  kind?: 'box' | 'bigBox' | 'fill' | 'fill3/4';
  color?: 'white' | 'paper';
  gap?: boolean;
}

export const WhitePanel = forwardRef<HTMLDivElement, WhitePanelProps>(
  (
    {
      children,
      className,
      mode = 'basic',
      kind = 'box',
      color = 'white',
      gap = false,
    },
    ref,
  ) => (
    <Panel
      ref={ref}
      className={clsx(
        'panel text-black rounded-[28px] shadow-[0_12px_32px_rgba(0,0,0,0.18)]',
        mode === 'letter' &&
          'panel-letter flex justify-center items-center align-middle font-sassoonInfant text-[300px]/[300px]',
        kind === 'box' && 'w-80 h-80',
        kind === 'bigBox' && 'w-full aspect-square sm:w-[500px] sm:h-[500px]',
        kind === 'fill' && 'w-full h-full',
        kind === 'fill3/4' && 'w-3/4 h-full',
        gap && 'mt-24',
        className,
      )}
      bgColorClassName={`bg-${color}`}
    >
      {children}
    </Panel>
  ),
);

WhitePanel.displayName = 'WhitePanel';
